// src/pages/ContactPage.js
import React from 'react';
import '../styles/components/ContactPage.scss';

const ContactPage = () => {
  const contactMethods = [
    {
      icon: 'fas fa-map-marker-alt',
      title: 'Our Location',
      details: ['Plot A2605, Meanwood Kwamwena', 'Lusaka, Zambia'],
      description: 'Visit our conveniently located office',
      color: '#e53e3e'
    },
    {
      icon: 'fas fa-phone',
      title: 'Call Us',
      details: ['+260 97 9788835', '+260 96 6196623'],
      description: 'Available during business hours',
      color: '#3182ce'
    },
    {
      icon: 'fas fa-clock',
      title: 'Business Hours',
      details: ['Mon - Fri: 8:00 AM - 5:00 PM', 'Saturday: 9:00 AM - 1:00 PM'],
      description: 'We\'re here to serve you',
      color: '#d69e2e'
    }
  ];

  // WhatsApp contact details
  const whatsappNumber = '+260979788835';
  const whatsappMessage = 'Hello! I would like to get more information about your consulting services.';

  // Try different path approaches
  const heroStyle = {
    backgroundImage: `linear-gradient(135deg, rgba(26, 54, 93, 0.8) 0%, rgba(229, 62, 62, 0.6) 100%), url('images/contact.jpg')`
  };

  return (
    <div className="contact-page">
      {/* Hero Section with Background Image */}
      <section className="contact-hero" style={heroStyle}>
        <div className="hero-overlay">
          <div className="container">
            <div className="hero-content">
              <div className="hero-text">
                <h1>Get In Touch</h1>
                <p className="hero-description">
                  Ready to transform your organization? Let's start a conversation about 
                  how we can help you achieve your goals with our expert consulting services.
                </p>
                
                {/* Primary Call-to-Action Buttons */}
                <div className="cta-buttons-hero">
                  <a 
                    href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-whatsapp"
                  >
                    <i className="fab fa-whatsapp"></i>
                    Chat on WhatsApp
                  </a>
                  <a 
                    href="mailto:dythelconsulting@gmail.com"
                    className="btn btn-email"
                  >
                    <i className="fas fa-envelope"></i>
                    Send Us an Email
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Rest of your component remains the same */}
      <section className="quick-contact-bar">
        <div className="container">
          <div className="quick-contact-content">
            <div className="contact-info">
              <i className="fas fa-comments"></i>
              <div>
                <h4>Quick Response Guaranteed</h4>
                <p>We respond within 2 hours during business hours</p>
              </div>
            </div>
            <div className="quick-actions">
              <a 
                href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="quick-btn"
              >
                <i className="fab fa-whatsapp"></i>
                WhatsApp
              </a>
              <a href="tel:+260979788835" className="quick-btn">
                <i className="fas fa-phone"></i>
                Call Now
              </a>
              <a href="mailto:dythelconsulting@gmail.com" className="quick-btn">
                <i className="fas fa-envelope"></i>
                Email
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Information Section */}
      <section className="contact-info-section">
        <div className="container">
          <div className="section-header">
            <h2>Contact Information</h2>
            <p>Multiple ways to reach us. Choose what works best for you.</p>
          </div>

          <div className="contact-grid">
            {contactMethods.map((method, index) => (
              <div key={index} className="contact-card">
                <div className="card-icon" style={{ color: method.color }}>
                  <i className={method.icon}></i>
                </div>
                <h3>{method.title}</h3>
                <div className="card-details">
                  {method.details.map((detail, idx) => (
                    <p key={idx}>{detail}</p>
                  ))}
                </div>
                <p className="card-description">{method.description}</p>
                {method.title === 'Our Location' && (
                  <a 
                    href="https://maps.google.com/?q=Plot A2605, Meanwood Kwamwena, Lusaka, Zambia" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="card-action"
                  >
                    <i className="fas fa-directions"></i>
                    Get Directions
                  </a>
                )}
                {method.title === 'Call Us' && (
                  <a href="tel:+260979788835" className="card-action">
                    <i className="fas fa-phone"></i>
                    Call Now
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="final-cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Start Your Project?</h2>
            <p>Don't wait any longer. Get in touch with us today and let's discuss how we can help you achieve your goals.</p>
            <div className="cta-buttons">
              <a 
                href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-large btn-whatsapp"
              >
                <i className="fab fa-whatsapp"></i>
                Chat on WhatsApp
              </a>
              <a 
                href="mailto:dythelconsulting@gmail.com"
                className="btn btn-large btn-email"
              >
                <i className="fas fa-envelope"></i>
                Send Email
              </a>
              <a href="tel:+260979788835" className="btn btn-large btn-call">
                <i className="fas fa-phone"></i>
                Call Us Now
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;